window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.Popper = require('popper.js').default;
    window.$ = window.jQuery = require('jquery');

    require('bootstrap');
} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios').default;
require('./utils/xhrFallbackAdapter').default(window.axios);

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

let token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
}

/**
 * On a CSRF token mismatch (419), refresh the token from the server and
 * retry the request once. This applies to every axios call in the app,
 * since all of it shares this one instance.
 */
window.axios.interceptors.response.use(
    response => response,
    async error => {
        const status = error && error.response && error.response.status;
        const isCsrfTokenRequest = error.config && error.config.url && error.config.url.includes('/csrf-token');

        if (status === 419 && !isCsrfTokenRequest && !error.config._csrfRetried) {
            try {
                const { data } = await window.axios.get('/csrf-token');
                window.axios.defaults.headers.common['X-CSRF-TOKEN'] = data.token;

                const meta = document.head.querySelector('meta[name="csrf-token"]');
                if (meta) meta.setAttribute('content', data.token);

                error.config._csrfRetried = true;
                error.config.headers['X-CSRF-TOKEN'] = data.token;
                return window.axios(error.config);
            } catch (retryError) {
                return Promise.reject(retryError);
            }
        }

        return Promise.reject(error);
    }
);

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     encrypted: true
// });
